import React from 'react'

export default function Processes() {
    return (
        <section className="process-section pb-100">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-8">
                    <div className="section-title">
                        <span>
                            <i className="flaticon-care-about-plants"></i>
                            Our process
                        </span>
                        <h2>To have become a volunteer or donor for poor</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="process-item">
                                <div className="icon">
                                    <i className="flaticon-support"></i>
                                </div>
                                <h3>Select Position</h3>
                                <p>Our first step is for you select the role you are ready and willing to play as a volunteer of Child Hope team.</p>
                                <a href="_" className="process-btn">Give Requist +</a>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="process-item">
                                <div className="icon">
                                    <i className="flaticon-confirmation"></i>
                                </div>
                                <h3>Get Confirmation</h3>
                                <p>Once you select the position you want to volunteer for, wait for confirmation from Child Hope.</p>
                                <a href="_" className="process-btn">Get Reaction +</a>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 offset-sm-3 offset-lg-0">
                            <div className="process-item">
                                <div className="icon">
                                    <i className="flaticon-enjoy"></i>
                                </div>
                                <h3>Get Enjoyed</h3>
                                <p>Next step is for you to volunteer and help give a child in need a boast to a better life!</p>
                                <a href="_" className="process-btn">Enjoy Now +</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="process-image">
                        <img src="assets/img/process.png" alt="Process"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}
